import { Component, Input } from '@angular/core';

@Component({
    selector: 'kpi-group',
    templateUrl: './kpiGroup.component.html',
    styleUrls: ['./kpiGroup.component.css'],
    standalone: false
})
export class KpiGroupComponent {
    @Input() public title: string;
    @Input() public allowRefresh: boolean;
    @Input() public subtitle: string;
    constructor() {

    }
}